import { toast } from '../../../../utils/messageUtils';

export const uploadTranslatedQuestionsStart = (state, payload) => {
    return {
        ...state,
        newWizardUploadTranslatedQuestionsApi: {
            isProcessing: true,
            error: false
        }
    }
}

export const uploadTranslatedQuestionsSuccess = (state, payload) => {
    toast.success('Questions uploaded successfully' );
    return {
        ...state,
        newWizardUploadTranslatedQuestionsApi: {
            isProcessing: false,
            error: false
        },
    }

}

export const uploadTranslatedQuestionsFailed = (state, payload) => {
    toast.error('Failed to upload');
    return {
        ...state,
        newWizardUploadTranslatedQuestionsApi: {
            isProcessing: false,
            error: true
        }
    }

}


export const checkTranslatedQuestionsStart = (state, payload) => {
    return {
        ...state,
        newWizardCheckTranslatedQuestionsApi: {
            isProcessing: true,
            error: false
        }
    }

}

export const checkTranslatedQuestionsSuccess = (state, payload) => {
    return {
        ...state,
        newWizardCheckTranslatedQuestionsApi: {
            isProcessing: false,
            error: false,
            data: payload.data.data
        },
    }

}

export const checkTranslatedQuestionsFailed = (state, payload) => {
    return {
        ...state,
        newWizardCheckTranslatedQuestionsApi: {
            isProcessing: false,
            error: payload,
        }
    }

}